export default __webpack_public_path__ + "static/10-d80ab47d49815d9e4fba58f28e43fa43.jpg";